import request from './adminRequest'

export const referralApi = {
  listReferral (params) {
    return request.get('/referrals', { params: params })
  },
  getReferral (id) {
    return request.get('/referrals/' + id)
  },
  saveReferral (data) {
    return request.post('/referrals', data)
  },
  updateReferral (id, data) {
    return request.put('/referrals/' + id, data)
  },
  deleteReferral (id) {
    return request.delete('/referrals/' + id)
  },
  publishAll (data) {
    return request.put('/referrals/', data)
  },
}
export default referralApi
